"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.VEHICLE_LOCATION_ENDPOINTS = {
    getVehicleLocations: '/backoffice/cs-fleet/{{version}}/vehicle-locations',
    postVehicleLocation: '/backoffice/cs-fleet/{{version}}/vehicle-locations',
    putVehicleLocation: '/backoffice/cs-fleet/{{version}}/vehicle-locations/{{uuid}}',
    deleteVehicleLocation: '/backoffice/cs-fleet/{{version}}/vehicle-locations/{{uuid}}',
};
/**
 * @private
 */
exports.LONG_DISTANCE_ENDPOINTS = {
    getLongDistanceList: '/backoffice/carsharing/{{version}}/vehicle-product-availabilities',
    postLongDistance: '/backoffice/carsharing/{{version}}/vehicle-product-availabilities',
    putLongDistance: '/backoffice/carsharing/{{version}}/vehicle-product-availabilities/{{uuid}}',
    deleteLongDistance: '/backoffice/carsharing/{{version}}/vehicle-product-availabilities/{{uuid}}',
};
/**
 * @private
 */
exports.UNAVAILABILITY_ENDPOINTS = {
    getUnavailabilityList: '/backoffice/carsharing/{{version}}/unavailabilities',
    postUnavailability: '/backoffice/carsharing/{{version}}/unavailabilities',
    putUnavailability: '/backoffice/carsharing/{{version}}/unavailabilities/{{uuid}}',
    deleteUnavailability: '/backoffice/carsharing/{{version}}/unavailabilities/{{uuid}}',
};
